// extracted by mini-css-extract-plugin
export var barContainer = "_34-0";
export var extraThin = "_34-3";
export var fillBar = "_34-6";
export var fillContainer = "_34-4";
export var overflow = "_34-8";
export var overflowContainer = "_34-5";
export var regular = "_34-7";
export var thick = "_34-1";
export var thin = "_34-2";